"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceSpectrum = void 0;
var _react = require("react");
var _browser = require("../utils/browser");
var _mediaQueryListener = require("../utils/mediaQueryListener");
const useDeviceSpectrum = () => {
  var _getBrowserGlobals, _mediaQuery$current;
  const window = (_getBrowserGlobals = (0, _browser.getBrowserGlobals)()) === null || _getBrowserGlobals === void 0 ? void 0 : _getBrowserGlobals.window;
  const mediaQuery = (0, _react.useRef)(window === null || window === void 0 ? void 0 : window.matchMedia('(prefers-color-scheme: dark)'));
  const _useState = (0, _react.useState)((_mediaQuery$current = mediaQuery.current) !== null && _mediaQuery$current !== void 0 && _mediaQuery$current.matches ? 'dark' : 'light'),
    deviceSpectrum = _useState[0],
    setDeviceSpectrum = _useState[1];
  const mediaQueryListEventHandler = (0, _react.useCallback)(matches => matches ? setDeviceSpectrum('dark') : setDeviceSpectrum('light'), [setDeviceSpectrum]);
  (0, _react.useEffect)(() => {
    const listener = ({
      matches
    }) => mediaQueryListEventHandler(matches);
    const currentMediaQuery = mediaQuery.current;
    (0, _mediaQueryListener.addMediaQueryListener)(currentMediaQuery, listener);
    return () => {
      (0, _mediaQueryListener.removeMediaQueryListener)(currentMediaQuery, listener);
    };
  }, [mediaQueryListEventHandler]);
  return deviceSpectrum;
};
exports.useDeviceSpectrum = useDeviceSpectrum;